import type {DocumentPartsResponse} from "../types";
import RenderNodeFactory from "../RenderNodeFactory";
import {ruleset} from "../renderRules";
import {augmentations} from "../augmentations";
import articleClasses from "../HtmlArticle.module.css";
import panelClasses from "./panelContent.module.css";

const {renderNode} = RenderNodeFactory({
    ruleset,
    augmentations,
    modifiers: [],
});

export const PanelDocumentParts = ({data}: {data: DocumentPartsResponse}) => {
    return (
        <div className={articleClasses.content}>
            {data.parts.map((part, index) => (
                <div className={panelClasses.part} key={`part-${index}`}>
                    {renderNode(
                        part,
                        part.root[0].id,
                        {skipAugmentations: true},
                        `part-${index}`
                    )}
                </div>
            ))}
        </div>
    );
};
